export function formatMicroFrontUrl(url) {
    var _a;
    if (((_a = window.LcapMicro) === null || _a === void 0 ? void 0 : _a.proxyPrefix) && (url === null || url === void 0 ? void 0 : url.startsWith("/")) && !url.startsWith("//"))
        url = `${window.LcapMicro.proxyPrefix}${url}`;
    return url;
}
export function formatMicroFrontRouterPath(path) {
    var _a;
    if (((_a = window.LcapMicro) === null || _a === void 0 ? void 0 : _a.routePrefix) && (path === null || path === void 0 ? void 0 : path.startsWith("/")) && !path.startsWith("//"))
        path = `${window.LcapMicro.routePrefix}${path}`;
    return path;
}
